export const getters = {
  getLeads($state) {
    return $state.sortOrder.map(cnpj => $state.records[cnpj]);
  },
  getLead: $state => cnpj => $state.records[cnpj] || {},
  getMeta($state) {
    return $state.meta;
  },
  getFacets($state) {
    return $state.facets;
  },
  getAppliedFilters($state) {
    return $state.appliedFilters;
  },
  getCredits($state) {
    return $state.credits;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};
